module.exports = __webpack_public_path__ + "img/proka-avatar.963faef7.png";